import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, X, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const items = [{
  title: 'TOMO 7 · Cuando reprobás',
  without: 'Si reprobás, quedás solo con la frustración y sin saber cómo volver. La mayoría abandona la carrera después de un golpe así.',
  with: 'Tenés el único tomo del mercado que te habla directamente a ese momento. Protocolo emocional, análisis de qué falló y plan concreto para el recuperatorio. Paso a paso.'
}, {
  title: 'TOMO 8 · Estudio sostenible',
  without: 'El próximo cuatrimestre va a ser exactamente igual que este. El mismo ciclo de crisis, el mismo pánico, el mismo agotamiento.',
  with: 'Un sistema para que nunca más llegues al límite. Calendario real, hábitos mínimos y estrategia para sostener el rendimiento todo el año.'
}, {
  title: 'BONO 5 · Técnicas por tipo de examen',
  without: 'Prepararte para un oral igual que para un múltiple opción es uno de los errores más costosos. Cada formato tiene sus reglas.',
  with: 'Estrategia específica para oral, escrito de desarrollo, múltiple opción, trabajos prácticos y virtuales. Acá están todas.'
}, {
  title: 'BONO 6 · Estudio en grupo',
  without: 'Sin saber cuándo y cómo estudiar en grupo, lo que debería sumar termina siendo tu mayor distracción.',
  with: 'El sistema para convertir el grupo en una ventaja real: técnicas colaborativas, cómo armarlo, a quién invitar y cuándo estudiar solo vs. en grupo.'
}];
export function WhatYouLose() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % items.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + items.length) % items.length);
  return <section className="py-20 px-6 lg:px-8 bg-cream" data-id="element-268">
      <div className="max-w-[900px] mx-auto" data-id="element-269">
        <div className="text-center mb-12" data-id="element-270">
          <h2 className="text-3xl md:text-5xl font-extrabold mb-4 uppercase text-red-600" data-id="element-271">
            ¿QUÉ PERDÉS SI ELEGÍS SOLO EL PACK ESENCIAL?
          </h2>
          <p className="text-xl text-dark/80 font-bold" data-id="element-272">
            El Pack Total incluye 2 tomos y 2 bonos que no están en ningún otro
            lugar
          </p>
        </div>

        <div className="relative bg-white rounded-3xl shadow-sm border border-border p-6 md:p-10 mb-12" data-id="element-273">
          <div className="flex justify-between items-center mb-8" data-id="element-274">
            <button onClick={prev} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-275">
              <ChevronLeft size={24} data-id="element-276" />
            </button>
            <div className="flex gap-2" data-id="element-277">
              {items.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-8 h-2 rounded-full transition-colors ${idx === currentIndex ? 'bg-salmon' : 'bg-border'}`} data-id="element-278" />)}
            </div>
            <button onClick={next} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-279">
              <ChevronRight size={24} data-id="element-280" />
            </button>
          </div>

          <div className="min-h-[250px]" data-id="element-281">
            <AnimatePresence mode="wait" data-id="element-282">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -20
            }} transition={{
              duration: 0.3
            }} data-id="element-283">
                <div className="text-center mb-8" data-id="element-284">
                  <span className="text-xs font-bold text-dark/50 tracking-widest uppercase mb-2 block" data-id="element-285">
                    EXCLUSIVO PACK TOTAL [{currentIndex + 1}/4]
                  </span>
                  <h3 className="text-2xl md:text-3xl font-extrabold" data-id="element-286">
                    {items[currentIndex].title}
                  </h3>
                </div>

                <div className="grid md:grid-cols-2 gap-6" data-id="element-287">
                  <div className="bg-red-50 p-6 rounded-2xl border border-red-100 relative" data-id="element-288">
                    <div className="absolute -top-3 left-6 bg-red-100 text-red-700 text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1" data-id="element-289">
                      <X size={14} data-id="element-290" /> Sin Pack Total
                    </div>
                    <p className="text-dark/80 mt-2" data-id="element-291">
                      {items[currentIndex].without}
                    </p>
                  </div>
                  <div className="bg-green-50 p-6 rounded-2xl border border-green-100 relative" data-id="element-292">
                    <div className="absolute -top-3 left-6 bg-green-100 text-green-700 text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1" data-id="element-293">
                      <Check size={14} data-id="element-294" /> Con Pack Total
                    </div>
                    <p className="font-bold text-dark mt-2" data-id="element-295">
                      {items[currentIndex].with}
                    </p>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>

        <div className="text-center" data-id="element-296">
          <p className="text-2xl md:text-3xl font-extrabold mb-8" data-id="element-297">
            Por $10.000 más, tenés el sistema completo para esta época y para
            toda tu carrera.
          </p>
          <button onClick={() => document.getElementById('precios')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-salmon hover:bg-salmon/90 text-dark font-extrabold text-xl md:text-2xl py-5 px-8 md:px-12 rounded-full shadow-lg transform transition hover:scale-105 w-full md:w-auto" data-id="element-298">
            💥 QUIERO EL PACK TOTAL — $29.990
          </button>
        </div>
      </div>
    </section>;
}